// Put inside of ng-repeat before col-* element
// For reference: getbootstrap.com/css/#responsive-utilities
// getbootstrap.com/css/#grid-responsive-resets
angular.module('aprima-core-ui').directive('ngRepeatColumnReset', [
    function () {
        'use strict';

        return {
            restrict: 'E',
            scope: {
                xs: '<?',
                sm: '<?',
                md: '<?',
                lg: '<?',
                index: '<',
                display: '@'
                //display can be block, inline-block, or inline
            },
            templateUrl: '/core-ui/views/directives/ngRepeatColumnReset.html'
        };
    }
]);